<div class="page">
  <!-- Header primește stările ca input -->
  <app-header
    [hidden]="hidden"
    [scrolled]="scrolled"
    [class.hidden]="hidden"
    [class.scrolled]="scrolled" />

  <main #contentRef class="content">
    <router-outlet />
  </main>

  <app-footer />

  @defer (on idle) {
    <app-lead-popup />
  }

  <button
    type="button"
    class="whatsapp-fab cj-baloo"
    [class.whatsapp-fab--visible]="fabVisible"
    aria-label="Scrie-ne pe WhatsApp"
    (click)="onWhatsAppClick()"
  >
    <svg class="whatsapp-fab__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
      <path fill="currentColor" d="M16.01 3.2c-7.06 0-12.8 5.65-12.8 12.61 0 2.23.6 4.41 1.73 6.32L3.1 28.8l6.86-1.79a13.02 13.02 0 0 0 6.05 1.51c7.06 0 12.8-5.65 12.8-12.61S23.07 3.2 16.01 3.2Zm0 23.18c-1.91 0-3.78-.51-5.41-1.48l-.39-.23-4.07 1.06 1.09-3.87-.26-.4a10.29 10.29 0 0 1-1.62-5.55c0-5.78 4.78-10.48 10.66-10.48s10.66 4.7 10.66 10.48-4.78 10.47-10.66 10.47Zm5.84-7.84c-.32-.16-1.9-.92-2.2-1.02-.29-.11-.51-.16-.72.16-.21.31-.82 1.02-1 1.23-.19.21-.37.24-.69.08-.32-.16-1.36-.49-2.59-1.56-.96-.84-1.61-1.88-1.8-2.19-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.19.21-.32.32-.53.11-.21.05-.39-.03-.55-.08-.16-.72-1.7-.98-2.33-.26-.61-.52-.53-.72-.54h-.61c-.21 0-.55.08-.84.39-.29.32-1.1 1.05-1.1 2.57s1.13 2.98 1.29 3.19c.16.21 2.23 3.34 5.4 4.68.75.32 1.34.51 1.8.65.76.24 1.45.21 2 .13.61-.09 1.9-.76 2.17-1.5.27-.74.27-1.37.19-1.5-.08-.13-.29-.21-.61-.37Z"/>
    </svg>
    <span class="whatsapp-fab__text" [class.whatsapp-fab__text--visible]="ctaVisible">{{ ctaText }}</span>
  </button>
</div>
